import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class ThemeHandle extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    let themePref = 'LIGHT';
    let themeClass = 'vt-dark';

    if (localStorage.getItem('_vt_theme')) {
      themePref = localStorage.getItem('_vt_theme');
    }

    const body = document.getElementById('vt-body');

    switch (themePref) {
      case 'DARK':
      themeClass = 'vt-dark';
        break;
      case 'LIGHT':
      themeClass = 'vt-light';
        break;
      default:
        themeClass = 'vt-light';
        break;
    }

    if (body) {
      body.className = themeClass;
    }
  }

  render() {
    return (
      this.props.children
    );
  }
}

const mapStateToProps = (state) => ({
  assets: state.assets.assets,
  pairs: state.assets.pairs,
  errors: state.assets.errors,
});

export default withRouter(connect(mapStateToProps)(ThemeHandle));
